module.exports = __webpack_public_path__ + "static/media/activities-image-2.e9753b9d.png";